import { render } from "./TrafficAndProspectsTable.vue?vue&type=template&id=0b16b932&scoped=true"
import script from "./TrafficAndProspectsTable.vue?vue&type=script&lang=js"
export * from "./TrafficAndProspectsTable.vue?vue&type=script&lang=js"

import "./TrafficAndProspectsTable.vue?vue&type=style&index=0&id=0b16b932&lang=scss&scoped=true"
import "./TrafficAndProspectsTable.vue?vue&type=style&index=1&id=0b16b932&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16b932"]])

export default __exports__